export default "__VITE_ASSET__bdc19e43__"